import Eyebrow from '../../../../../components/blackrock/advisor-center/eyebrow/Eyebrow';
import { PollCTA } from './PollCTA';
import { CTAWithIntro } from '../Poll.model';
import './PollCTAContainer.scss';

const PollCTAContainer: React.FC<{
	ctas: CTAWithIntro[];
	answered?: number;
	yourVoteLabel?: string | null;
}> = ({ ctas, answered, yourVoteLabel }) => {
	const sortedCtas: CTAWithIntro[] = [...ctas];
	if (answered) {
		const selected = sortedCtas.splice(answered, 1)[0];
		sortedCtas.unshift(selected);
	}

	return sortedCtas.length > 1 ? (
		<div className="blk-ac-poll-cta-container multiple">
			{yourVoteLabel && (
				<Eyebrow icon="fa fa-check-circle" tag={yourVoteLabel}></Eyebrow>
			)}
			<div className="cta-list">
				{sortedCtas.map((c) => (
					<PollCTA
						key={'poll-cta-' + c.callToAction.url + c.callToAction.label}
						label={c.callToAction.label}
						url={c.callToAction.url}
						description={c.description}
						target={c.callToAction.target}
						ariaLabel={c.callToAction.ariaLabel}
						dataLinkEvent={c.callToAction.dataLinkEvent}
					/>
				))}
			</div>
		</div>
	) : (
		<div className="blk-ac-poll-cta-container single">
			{sortedCtas.map((c) => (
				<PollCTA
					key={'poll-cta-' + c.callToAction.url}
					label={c.callToAction.label}
					url={c.callToAction.url}
					description={c.description}
					target={c.callToAction.target}
					ariaLabel={c.callToAction.ariaLabel}
					dataLinkEvent={c.callToAction.dataLinkEvent}
				/>
			))}
		</div>
	);
};

export default PollCTAContainer;
